<script>
    import { mapState } from 'vuex';

    export default {
        name: 'hidden-password-inputs',

        props: {
            inputName: {
                type: String,
                default: null
            }
        },

        computed: {
            ...mapState('passwordSettings', [
                'passwordForm'
            ])
        }
    }
</script>
<template>
    <div>
        <input
            type="hidden"
            name="password"
            :value="passwordForm.password"
        />
        <input
            type="hidden"
            name="new_password"
            :value="passwordForm.newPassword"
        />
        <input
            type="hidden"
            name="confirm_password"
            :value="passwordForm.confirmPassword"
        />
    </div>
</template>